import StopScheduledReportScreen from './StopScheduledReportScreen';

export default StopScheduledReportScreen;
